export const TREATMENT_STATUS = {
  FLAGGED: "flagged",
  IN_PROGRESS: "in_progress",
  HANDLED: "handled",
} as const;

export type TreatmentStatusValue =
  (typeof TREATMENT_STATUS)[keyof typeof TREATMENT_STATUS];

export const TREATMENT_STATUS_OPTIONS = [
  { value: TREATMENT_STATUS.FLAGGED, label: "סומן לטיפול" },
  { value: TREATMENT_STATUS.IN_PROGRESS, label: "בטיפול" },
  { value: TREATMENT_STATUS.HANDLED, label: "טופל" },
] as const;

export const TREATMENT_STATUS_LABELS: Record<TreatmentStatusValue, string> = {
  flagged: "סומן לטיפול",
  in_progress: "בטיפול",
  handled: "טופל",
};

export const TREATMENT_STATUS_STYLES: Record<
  TreatmentStatusValue,
  { bg: string; color: string; border: string }
> = {
  flagged: {
    bg: "rgba(245, 158, 11, 0.14)",
    color: "#B45309",
    border: "rgba(245, 158, 11, 0.35)",
  },
  in_progress: {
    bg: "rgba(59, 130, 246, 0.12)",
    color: "#1D4ED8",
    border: "rgba(59, 130, 246, 0.32)",
  },
  handled: {
    bg: "rgba(34, 197, 94, 0.12)",
    color: "#15803D",
    border: "rgba(34, 197, 94, 0.32)",
  },
};

export function isOpenTreatmentStatus(status: string | null | undefined): boolean {
  return status === TREATMENT_STATUS.FLAGGED || status === TREATMENT_STATUS.IN_PROGRESS;
}
